import styled from 'styled-components';

const StyledActions = styled.div`
  display: flex;
  justify-content: flex-end;
`;

type Props = {
  children: React.ReactNode;
};

export const HeaderActions = ({ children }: Props) => {
  return <StyledActions>{children}</StyledActions>;
};
